import { CommonModule } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
  OnInit,
} from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { availableLanguages } from './core/constants/langConst';
import { HttpClientModule } from '@angular/common/http';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SwUpdateService } from './services/sw-update.service';
@Component({
  selector: 'logibids-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    NgxUiLoaderModule,
    TranslateModule,
    HttpClientModule,
    ToastModule,
    ConfirmDialogModule,
  ],
  providers: [TranslateService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AppComponent implements OnInit {
  title = 'logibids_admin';
  availableLanguages = availableLanguages;
  constructor(
    public translate: TranslateService,
    private router: Router,
    private swUpdateService: SwUpdateService
  ) {
    this.translate.addLangs(this.availableLanguages);
    this.translate.use(this.availableLanguages[0]);
    this.translate.setDefaultLang(this.availableLanguages[0]);
  }

  ngOnInit(): void {
    this.swUpdateService.checkForUpdates();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        document.body.scrollTop = 0;
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 0);
      }
    });
  }
}
